export default __webpack_public_path__ + "static/PSz2_Piotr Szular-d9cba0a78d9e43353b06e75089307c1c.jpg";